import { useTranslation } from 'react-i18next';
import { PartyPopper } from 'lucide-react';

import { useMainButton } from '@/hooks/useMainButton';

interface DoneStepProps {
  onTour: () => void;
  onStart: () => void;
}

export function DoneStep({ onTour, onStart }: DoneStepProps) {
  const { t } = useTranslation('onboarding');

  useMainButton({ text: t('done.tour'), onClick: onTour });

  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 px-6 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-brand/10 text-brand">
        <PartyPopper aria-hidden className="h-8 w-8" />
      </span>
      <h1 className="text-2xl font-bold text-fg">{t('done.title')}</h1>
      <p className="text-sm text-fg-muted">{t('done.body')}</p>
      <button
        type="button"
        onClick={onStart}
        className="text-xs font-semibold text-fg-muted underline"
      >
        {t('done.start')}
      </button>
    </div>
  );
}
